module.exports = __webpack_public_path__ + "static/media/Política reclamaciones.779e63d8.pdf";